 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime~main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"banner":"banner","cards":"cards","common":"common","accordion":"accordion","caveats":"caveats","content-blocks":"content-blocks","fund-cards":"fund-cards","fund-compare":"fund-compare","fund-press-releases":"fund-press-releases","marketo-form":"marketo-form","cta-banner":"cta-banner","datadog":"datadog","dynamic-cards":"dynamic-cards","image-grid":"image-grid","interactive-content":"interactive-content","link-list":"link-list","tax":"tax","Latest Dividends":"Latest Dividends","literature":"literature","njbest-treasurry-managed-layout":"njbest-treasurry-managed-layout","on-page-search":"on-page-search","profile":"profile","role-selector-cards":"role-selector-cards","fund-attribution":"fund-attribution","product-detail-layout":"product-detail-layout","morningstar-table":"morningstar-table","product-details":"product-details","section-nav":"section-nav","us-index":"us-index","table-with-filters":"table-with-filters","vendor.async.xlsx":"vendor.async.xlsx","article":"article","german-calculator-one-time-investment":"german-calculator-one-time-investment","german-calculator-pension":"german-calculator-pension","german-calculator-savings-plan":"german-calculator-savings-plan","german-calculator-withdrawl-plan":"german-calculator-withdrawl-plan","australia-fund-platforms":"australia-fund-platforms","njbest-get-started":"njbest-get-started","njbest-portfolio-selector":"njbest-portfolio-selector","retirement-lifestyle-tool":"retirement-lifestyle-tool","us-index-allocations":"us-index-allocations","us-index-banner":"us-index-banner","us-index-performance":"us-index-performance","what-happened-last-week":"what-happened-last-week","cpreif-location-map":"cpreif-location-map","cpreif-portfolio-tool":"cpreif-portfolio-tool","dynamic-dropdown-tool":"dynamic-dropdown-tool","fixed-income-fine-tuning":"fixed-income-fine-tuning","effective-annual-costs":"effective-annual-costs","munimap":"munimap","news-feeds-tool":"news-feeds-tool","pcstool":"pcstool","popquiz":"popquiz","mifid-calculator":"mifid-calculator","njbest-treasury-managed-price-and-performance":"njbest-treasury-managed-price-and-performance","literature-audit":"literature-audit","vendor.async.gaugeJS":"vendor.async.gaugeJS","recession-dashboard":"recession-dashboard","njbest-contribution-calculator":"njbest-contribution-calculator","quotential-questionnaire":"quotential-questionnaire"}[chunkId]||chunkId) + "-es2015." + {"0":"22c5e792d54b02884d5b","banner":"eaa11c5a374025452241","cards":"cde4a9e592e150290d00","common":"f2a465f9b95757f3dc03","accordion":"d1704cd7902544b9df08","caveats":"4873c39abc221d56a62e","content-blocks":"549d5654475de0a8eb12","fund-cards":"4d8892cee4e5877d0eb3","fund-compare":"672e197a1f8efc9119fa","fund-press-releases":"4429167e2104bf8bbe98","marketo-form":"af33e51cd4c90650c659","cta-banner":"e0bc3ed0c8c8305896aa","datadog":"88afdd97cb608b01a655","dynamic-cards":"a207eb70e691f4d9a89d","image-grid":"7afe1f82999a0ae66510","interactive-content":"bdf3644f9cb7c94b26b9","link-list":"521902479920e7502810","tax":"5c47d582686fba3547bb","Latest Dividends":"2bc8b7bd22b240dfc26a","literature":"62968521c31d35dfa5cc","njbest-treasurry-managed-layout":"9fa39515bcacd47fa4ea","on-page-search":"41844ca15274d9633e45","profile":"1957dd465aaa15b185b9","role-selector-cards":"ab3d65e598c5f48cf6f5","fund-attribution":"d5a04bf25460e50683d5","product-detail-layout":"1e9d8a8a68dafb92829d","morningstar-table":"695ae52d3d906e598814","product-details":"cf048ad2237b95b37e17","section-nav":"f9365121f31f00fd009b","us-index":"e0aa7c4d779d379cc9ce","table-with-filters":"6e3b844c3c5e0167c9fb","vendor.async.xlsx":"1c293854145bccbf7452","article":"6e18c27777ffc163db6f","german-calculator-one-time-investment":"39f858b412c1a76f858d","german-calculator-pension":"ae64690b3b44815e137f","german-calculator-savings-plan":"9151ddcc19de396ba012","german-calculator-withdrawl-plan":"7a26977aafe8173ddda0","australia-fund-platforms":"62871469410e85d6b72c","njbest-get-started":"0f448472f95cfef25aa2","njbest-portfolio-selector":"c4c0be7028e156c96304","retirement-lifestyle-tool":"1f8e443cb77ff53b7ae4","us-index-allocations":"75a183e3a8738cfeea9a","us-index-banner":"64565d5614eed2a7ba06","us-index-performance":"1d0feab1cac9c0c23935","what-happened-last-week":"49fb0b73f85346c4d6f3","cpreif-location-map":"ee531b2cad2fbfe9c92a","cpreif-portfolio-tool":"0fd82008606226260416","dynamic-dropdown-tool":"279f3b82efff95d9d8fa","fixed-income-fine-tuning":"b8a07cd78ad9e3cf262e","effective-annual-costs":"01073cff505004c3056b","munimap":"8cc60b3d9618342c4cfd","news-feeds-tool":"fabf6e3159ebcfbe4027","pcstool":"317b87d42b70a9c09bd2","popquiz":"b0695da211f192951e47","mifid-calculator":"d1fb2e85fb7c2c83fd30","njbest-treasury-managed-price-and-performance":"4bdd7fafbedf07c0107d","literature-audit":"45d174fe6f30d84a729d","vendor.async.gaugeJS":"ea9e8c90ca4f79ce542e","recession-dashboard":"ffe7689edf1f5e8d59ec","njbest-contribution-calculator":"6602d3a345c14348ef10","quotential-questionnaire":"f3d12a4fc5117d1f0c0a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
